import React from 'react';
import { FormSection } from '@atlaskit/form';
import { EditCreateInvoiceGroup } from '@css-xp/base';
import { ADDITIONAL_INVOICE_RECIPIENTS } from '@css-xp/ppc-constants';

interface InvoiceContactsStepProps {
  onUpdateAdminFieldsDirtyFlag: (flag: boolean) => void;
  defaultRecipients: string[];
  namePrefix?: string;
  validDomains?: string[] | null | undefined;
}

export const InvoiceContactsStep = ({
  onUpdateAdminFieldsDirtyFlag,
  defaultRecipients,
  namePrefix,
  validDomains,
}: InvoiceContactsStepProps) => {
  return (
    <FormSection>
      <div className="form-component-width" data-testId="Invoice contacts">
        <EditCreateInvoiceGroup
          recipients={defaultRecipients?.length > 0 ? defaultRecipients : ['']}
          updateAdminFieldsDirtyFlag={onUpdateAdminFieldsDirtyFlag}
          isRequired={false}
          placeholder={'Enter email address of the invoice recipient'}
          helperMessage={`Manage the ${ADDITIONAL_INVOICE_RECIPIENTS.toLowerCase()} for this billing profile.`}
          title={ADDITIONAL_INVOICE_RECIPIENTS}
          validDomains={validDomains}
          namePrefix={namePrefix}
        />
        <hr className="recipient-border" />
      </div>
    </FormSection>
  );
};
